module.exports = __webpack_public_path__ + "static/media/icon.aff43a9a.png";